import { Button, InputAdornment } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import TimePickerComp from './TimerPickerComp/TimerPickerComp';

import { Input, InputProps } from 'shared/elements';
import { CalendarIconTwoTone } from 'components/Icons';
import { useStyles } from './TimePicker.styles';
import clsx from 'clsx';

type Props = {
  startIcon?: React.ReactNode;
  onChooseTime?: (value: string, timezone?: string) => void;
  isShowTimezone?: boolean;
  label?: string;
  componentType?: 'button' | 'input';
  inputProps?: InputProps;
  value?: string;
  timezoneValue?: string;
  classes?: { button: string };
  buttonProps?: { error: boolean };
};
const TimePicker: React.FC<Props> = ({
  startIcon,
  onChooseTime,
  label,
  componentType,
  inputProps,
  value,
  classes,
  buttonProps,
  isShowTimezone,
  timezoneValue,
}) => {
  const rootClasses = useStyles();
  const [isDatePickerOpen, setIsDatePickerOpen] = useState<boolean>(false);
  const [inputText, setInputText] = useState<string | null>(null);

  // Open Date Picker Modal
  const handleOpenDatePicker = () => {
    setIsDatePickerOpen(true);
  };

  const handleCloseDatePicker = () => {
    setIsDatePickerOpen(false);
  };

  useEffect(() => {
    if (value) {
      setInputText(value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleSetInputText = (time: string) => {
    if (value) {
      setInputText(time);
    }
  };

  const renderComponentType = () => {
    switch (componentType) {
      case 'button':
        return (
          <Button
            variant="contained"
            startIcon={startIcon}
            onClick={() => handleOpenDatePicker()}
            classes={{
              root: clsx(classes?.button, {
                [rootClasses.buttonError]: buttonProps?.error,
              }),
            }}
          >
            {label}
          </Button>
        );
      case 'input':
        return (
          <div>
            <Input
              type="text"
              name="session_date"
              variant="outlined"
              fullWidth
              onClick={() => handleOpenDatePicker()}
              value={inputText}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <CalendarIconTwoTone style={{ width: '16px' }} />
                  </InputAdornment>
                ),
              }}
              {...inputProps}

              // errorMessage={getErrorMessage(form.touched.session_date, form.errors.session_date)}
            />
          </div>
        );

      default:
        break;
    }
  };

  return (
    <div>
      <div>{renderComponentType()}</div>

      <TimePickerComp
        open={isDatePickerOpen}
        onClose={handleCloseDatePicker}
        onChooseTime={onChooseTime}
        handleSetInputText={handleSetInputText}
        defaultValue={value}
        isShowTimezone={isShowTimezone}
        timezoneValue={timezoneValue}
      />
    </div>
  );
};

export default TimePicker;

TimePicker.defaultProps = {
  componentType: 'button',
};
